import Swiper, { EffectFade, Autoplay, Thumbs, Navigation } from "swiper";

const navSlider = new Swiper(".testimonials-carousel .slider-navigation", {
  spaceBetween: 0,
  slidesPerView: 1,
  direction: "horizontal",
  breakpoints: {
    768: {
      slidesPerView: "auto",
      direction: "vertical",
    },
  },
});

const contentSlider = new Swiper(".testimonials-carousel .slider-content", {
  modules: [EffectFade, Autoplay, Thumbs, Navigation],
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  thumbs: {
    swiper: navSlider,
  },
  autoplay: {
    delay: 5000,
  },
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".testimonials-carousel .next",
    prevEl: ".testimonials-carousel .prev",
  },
  on: {
    init() {
      this.slides.forEach(function (slide, i) {
        slide.setAttribute("data-index", i);
      });
    },
  },
});

navSlider.on("slideChange", function () {
  const currentSlide = navSlider.slides[navSlider.activeIndex].dataset.index;
  contentSlider.slideTo(currentSlide, 500, true);
});

navSlider.on("tap", function () {
  const currentSlide = navSlider.clickedIndex;
  contentSlider.slideTo(currentSlide, 500, true);
});

contentSlider.on("slideChange", function () {
  const currentSlide = contentSlider.slides[contentSlider.activeIndex].dataset.index;
  navSlider.slideTo(currentSlide, 500, true);
});

contentSlider.on("tap", function () {
  const currentSlide = contentSlider.clickedIndex;
  navSlider.slideTo(currentSlide, 500, true);
});
